import color from "color";
import { DefaultTheme } from "styled-components";

export type VariantStyles = {
  basic: (textColor: string, theme: DefaultTheme) => string;
  bordered: (borderColor: string, theme: DefaultTheme) => string;
  filled: (background: string, theme: DefaultTheme) => string;
};

export const getTextColor = (textColor: string, _theme: DefaultTheme) => `
  color: ${textColor};

  &:hover {
    color: ${color(textColor).alpha(0.5)};
  }

  &:disabled {
    color: ${color(textColor).alpha(0.3)};
  }
`;

export const getBackgroundColor = (background: string, theme: DefaultTheme) => {
  const hasShadow = theme.buttonFilledShadow !== 'none';
  const textColor = color(background).luminosity() > theme.buttonLightBgThreshold ? '#000' : theme.buttonFilledText;
  return `
  background-color: ${background};
  color: ${textColor};
  box-shadow: ${hasShadow ? `0 3px 10px 0 ${color(background).alpha(0.5)}` : 'none'};

  &:hover {
    color: ${textColor};
    background-color: ${color(background).alpha(0.8)};
    box-shadow: ${hasShadow ? `0 1px 6px 0 ${color(background).alpha(0.8)}` : 'none'};
  }

  &:disabled {
    background-color: ${color(background).alpha(0.5)};
    box-shadow: ${hasShadow ? `0 1px 8px 0 ${color(background).alpha(0.5)}` : 'none'};
  }
`;
};

export const getBorderColor = (borderColor: string, theme: DefaultTheme) => `
  color: ${borderColor};
  background-color: ${theme.surfaceElevated};
  border: 0.5px solid ${borderColor};

  &:hover {
    color: ${color(borderColor).alpha(0.5)};
    border: 0.5px solid ${color(borderColor).alpha(0.5)};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${color(borderColor).alpha(0.3)};
    border: 0.5px solid ${color(borderColor).alpha(0.3)};
  }
`;

export const variantStyles: VariantStyles = {
  basic: getTextColor,
  bordered: getBorderColor,
  filled: getBackgroundColor,
};
